import React from "react";
import { RESOURCE_NAME } from "common/authorization";
import { Wrapper } from "../AddressPanel/__styles__/AddressPanel";
import { Layout } from "../AddressPanel/Records";
import { AuthContext } from "../Authorization/AuthContext";
import { Button } from "../Common/Button";
import { EmptyState } from "../Common/EmptyState";
import { useTaskModal } from "./Create";
import { TargetObject } from "./types";

const Tasks = ({ targetObject }: { targetObject: TargetObject }) => {
  const { authorized } = React.useContext(AuthContext);
  const [showTaskModal, hideTaskModal] = useTaskModal({
    targetObject,
    onSubmit: () => {
      hideTaskModal();
    },
    onCancel: () => {
      hideTaskModal();
    },
  });

  const canCreateTask = authorized({
    resource: RESOURCE_NAME.TASK,
    permission: "create",
  });

  const createButton = (
    <Button
      onClick={() => showTaskModal()}
      size="small"
      disabled={!canCreateTask}
      data-testid="createTask"
      leftIconName="plus"
      styleVariant="primary"
    >
      Add new
    </Button>
  );

  return (
    <Wrapper style={{ padding: "16px 16px 0" }}>
      <Layout title="Tasks" actionButton={createButton}>
        <EmptyState
          icon="no-activity-inbox"
          title="No tasks created"
          body="Add a task to get started."
        />
      </Layout>
    </Wrapper>
  );
};

export default Tasks;
